import LocalizedLink from '@/components/layout/LocalizedLink'
import { ChevronLeft } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  to?: string
}

interface LibraryBreadcrumbProps {
  items: BreadcrumbItem[]
}

export default function LibraryBreadcrumb({ items }: LibraryBreadcrumbProps) {
  return (
    <nav className="flex items-center gap-2 text-sm text-gray-600 mb-6" aria-label="Breadcrumb">
      <LocalizedLink to="/" className="hover:text-primary-600 transition-colors">
        الرئيسية
      </LocalizedLink>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          <ChevronLeft className="w-4 h-4" />
          {item.to ? (
            <LocalizedLink to={item.to} className="hover:text-primary-600 transition-colors">
              {item.label}
            </LocalizedLink>
          ) : (
            <span className="text-gray-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  )
}

